import { AuthenticationForm, AuthenticationUpdate, Authentication } from '@core/models'

export function transformToData(auth: Authentication): Authentication {
    return { ...auth };
}

export function transformToForm(auth: Authentication): AuthenticationForm {
    return {} as AuthenticationForm;
}

export function transformToUpsert(authenticationForm: AuthenticationForm): AuthenticationUpdate {
    if(authenticationForm?.termsAccepted)
        return {
            correo: authenticationForm.email as string,
            contrasena: authenticationForm.password as string,
            nombre: authenticationForm.name as string,
            apellido: authenticationForm.lastName as string,
            telefono: authenticationForm.phone as string,
            dni: authenticationForm?.identityCard,
            tipoDocumento: authenticationForm?.identityCardType
        }

    return {
        correo: authenticationForm.email as string,
        contrasena: authenticationForm.password as string
    }
}
